const TIPO_PESSOA = [
  { value: "PessoaFisica", label: "Pessoa Física" },
  {
    value: "PessoaJuridica",
    label: "Pessoa Jurídica (p.exemplo: empresa ou empregador)",
  },
];

export default TIPO_PESSOA;
